<app-header [redirectToHome]="false" [isPrimary]="false" (searchTypeChanged)="this.isShowingMap=false"></app-header>

<!-- BOX RICERCA -->
<div [hidden]="this.isShowingMap" class="containerSearchBanner">
  <div id="searchItemContainer" class="container pt-5 pb-3">
    <div class="row pt-5">
      <div class="col-md-12 pt-5 pb-2 noPadding position-relative">
        <app-search-bar-input (showMoreFiltersEvt)="openMoreFiltersPopup = true" [isAgent]="this.searchType == 'agente'"
          [isAgency]="this.searchType == 'agenzia'" (saveSearch)="this.saveSearches()" [isSaved]="this.savedSearch"
          (resetFilterEvent)="this.resetFilterFromSearchBar()"></app-search-bar-input>
      </div>
      <div class="col-md-12 pt-2 pb-2">
        <div class="researchResults">
          <p class="mx-0 mt-0 mb-2 p-0">
            <ng-container
              *ngIf="this.main.searchType === 'vendita' || this.main.searchType === 'affitto' || this.main.searchType === 'agenzia' || (this.main.searchType === 'agente' && !this.main.isAgentSearch)">
              <ng-container
                *ngIf="searchResultsAnnuncio || searchResultsAgency || searchResultsProfessionist; else loadingSubtitle">
                Abbiamo trovato {{
                searchResultsAnnuncio?.total || searchResultsAgency?.total ||
                searchResultsProfessionist?.total || '0'
                }} risultati nella zona cercata
              </ng-container>
            </ng-container>
            <ng-container *ngIf="this.main.searchType === 'agente' && this.main.isAgentSearch">
              <ng-container *ngIf="searchResultsAgent?.totalPlusAtecoAgents; else loadingSubtitle">
                Abbiamo trovato {{ searchResultsAgent?.totalPlusAtecoAgents }} Agenti con licenza attiva
                di cui {{ searchResultsAgent?.total }} registrati a Cercacasa
              </ng-container>
            </ng-container>
            <ng-template #loadingSubtitle>
              Sto cercando...
            </ng-template>
          </p>
          <h5 class="m-0 p-0 fw-lighter textCapitalize">{{ searchPlaceholder }}</h5>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- VISUALIZZAZIONE MAPPA -->
<div [hidden]="!this.isShowingMap"
  *ngIf="this.isShowingMap && (searchResultsAnnuncio || searchResultsAgency || searchResultsAgent || searchResultsProfessionist)">
  <app-ricerca-su-mappa [isAgentSelected]="this.isAgentSelected" (changeView)="this.changeView()"
    (messageEvent)="this.changeFromChild($event)" [searchQuery]="this.creatSearchQuery()" [searchType]="this.searchType"
    [searchResults]="searchResultsAnnuncio" [agencyResults]="searchResultsAgency" [agentResults]="searchResultsAgent"
    [professionistResult]="searchResultsProfessionist" [additionalFilters]="this.additionalFilters"
    [isLogged]="this.isLogged"></app-ricerca-su-mappa>
</div>

<!-- VISUALIZZAZIONE LISTA -->
<div [hidden]="this.isShowingMap" class="renderList">
  <div id="renderListCont" class="backgroundListingSilver">
    <div class="container">
      <div class="row">

        <!-- LISTA DEGLI ANNUNCI CERCATI -->
        <div class="col-lg-9 col-md-12 col-sm-12 listing-border">

          <div *ngIf="this.handleViewBoxGenericReq" class="card card-save-search" (click)="handleGenericRequest()">
            <h6 class="mb-2 pb-0"><i class="icon-comment me-2"></i>Chiedi agli agenti immobiliari esperti
              {{ this.createAgentLabel() }}</h6>
            <p class="pt-0 mt-0 mb-3">Chiedi agli agenti immobiliari {{ this.createAgentLabel() }} quali sono
              gli immobili che potrebbero soddisfare al meglio le tue richieste.</p>
            <button class="btn btn-primary mb-0">Fai una richiesta</button>
          </div>

          <!-- TESTO DA MOSTRARE QUANDO UN UTENTE HA EFFETTUATO UNA RICERCA CHE NON HA RESTITUITO ALCUN RISULTATO -->
          <ng-container
            *ngIf="this.retrySearchAgencyMessage || this.retrySearchAnnunciMessage || this.retrySearchProfessionistMessage || this.retrySearchAgentMessage">
            <div class="text-center text-message-results-no-filter">
              <i class="icon-search-minus text-primary icon-not-found"></i>
              <h5 class="m-0 fw-normal font-weight-600 text-primary">
                La ricerca filtrata non ha restituito risultati.
                <br>
                Di seguito alcuni contenuti simili a quelli che hai cercato.
              </h5>
            </div>
          </ng-container>

          <ng-container
            *ngIf="searchResultsAnnuncio || searchResultsAgency || searchResultsAgent || searchResultsProfessionist; else loadingResultList">
            <ng-container
              *ngIf="searchResultsAnnuncio?.listings?.length > 0 || searchResultsAgency?.agencies?.length > 0 || searchResultsAgency?.ateco_companies?.length > 0 || searchResultsAgent?.agents?.length > 0 || searchResultsAgent?.ateco_companies?.length > 0 || searchResultsProfessionist?.professionists?.length > 0; else noResults">
              <!-- FILTRA IL LISTING PER MAPPA O ORDINAMENTO -->
              <div class="cardFilters">
                <div class="cardFilters__left">
                  <div (click)="this.changeView()" class="cardFilters__left__item cursor-pointer">
                    <i class="icon-map-marker-alt"></i>
                    <span>Visualizza su Mappa</span>
                  </div>
                </div>
                <div class="cardFilters__right">
                  <div *ngIf="this.isAgentSelected === true" class="cardFilters__left__item cursor-pointer">
                    <i class="icon-sort-amount-down pe-1"></i>
                    <select *ngIf="this.searchType == 'vendita' || this.searchType == 'affitto'"
                      class="select-order cursor-pointer" (change)="this.orderListing($event.target.value)">
                      <option value="" [selected]="this.main?.orderList.order == ''">Ordina:
                        Rilevanti
                      </option>
                      <ng-container *ngFor="let orderFilter of getOrderFilters()">
                        <option [value]="orderFilter.name" [selected]="this.main?.orderList.order == orderFilter.name">
                          Ordina:
                          {{ orderFilter.name }}
                        </option>
                      </ng-container>
                    </select>

                    <select
                      *ngIf="this.searchType == 'agenzia' || this.searchType == 'agente' || this.searchType == 'professionista'"
                      class="select-order cursor-pointer" (change)="this.orderListing($event.target.value)">
                      <option value="" [selected]="this.main?.orderList.order == ''">Ordina:
                        Rilevanti
                      </option>
                      <ng-container *ngFor="let orderFilter of getOrderFilters()">
                        <option [value]="orderFilter.name" [selected]="this.main?.orderList.order == orderFilter.name">
                          Ordina:
                          {{ orderFilter.name }}
                        </option>
                      </ng-container>
                      <!-- <option value="nameAsc" [selected]="this.orderID == 'nameAsc'">Ordina: Numero immobili in vendita</option>
                      <option value="nameAsc" [selected]="this.orderID == 'nameAsc'">Ordina: Numero immobili in affitto</option> -->
                    </select>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-column">
                <ng-container *ngIf="this.searchType == 'vendita' || this.searchType == 'affitto'">
                  <ng-container *ngFor="let list of searchResultsAnnuncio?.listings; let i = index">
                    <div [style.order]="i">
                      <app-card-search-annuncio [isMobile]="this.isMobile" [listingObj]="getInListingObj(i)"
                        (openPopupFromCardEvt)="this.openPopup()" [isSaved]="true"
                        [annuncioObj]="list"></app-card-search-annuncio>
                    </div>
                  </ng-container>
                </ng-container>


                <!-- BANNER FINANZIARIA -->
                <div *ngIf="this.showProfessionist"
                  [hidden]="this.searchType == 'professionista' || this.searchType == 'agente' || this.searchType == 'agenzia'"
                  [style.order]="2">
                  <app-brand-banner [bannerName]="'auxilia'"
                    [imgUrl]="'assets/img/placeholders/auxilia-rect-banner.png'" [isResultsColumn]="true"
                    [marginTop]="15" [marginBottom]="0" [width]="550" [height]="190"></app-brand-banner>
                </div>
              </div>

              <ng-container *ngIf="this.searchType == 'agenzia'">
                <!-- AGENCY RESULTS for AGENCY SEARCH -->
                <app-card-search-agenzia (openPopupFromCardEvt)="this.openPopup()" [isSaved]="true"
                  *ngFor="let agency of searchResultsAgency?.agencies" [agencyObj]="agency"></app-card-search-agenzia>

                <!-- ATECO RESULTS for AGENCY SEARCH -->
                <app-card-search-ateco *ngFor="let agency of searchResultsAgency?.ateco_companies"
                  [atecoCompanyObj]="agency" [objType]="'agency'"></app-card-search-ateco>
              </ng-container>

              <ng-container *ngIf="this.searchType == 'agente'">
                <!-- AGENT RESULTS for AGENT SEARCH -->
                <app-card-search-agente (openPopupFromCardEvt)="this.openPopup()" [isSaved]="true"
                  *ngFor="let agent of searchResultsAgent?.agents" [agentObj]="agent"></app-card-search-agente>

                <!-- ATECO RESULTS for AGENT SEARCH -->
                <ng-container *ngFor="let agent of searchResultsAgent?.ateco_companies">
                  <app-card-search-ateco [atecoCompanyObj]="agent" [objType]="'agent'"></app-card-search-ateco>

                  <!-- ESPONENTI ATECO ALL' INTERNO DI OGNI RISULTATO -->
                  <ng-container *ngIf="agent.esponenti.length > 1">
                    <ng-container *ngFor="let esponente of agent.esponenti">
                      <ng-container *ngIf="esponente.name !== agent.esponenti[0].name">
                        <app-card-search-ateco [atecoCompanyObj]="agent" [esponente]="esponente"
                          [objType]="'agent'"></app-card-search-ateco>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>

              </ng-container>

              <ng-container *ngIf="this.searchType == 'professionista'">
                <app-card-search-professionista (openPopupFromCardEvt)="this.openPopup()" [isSaved]="true"
                  *ngFor="let professionist of searchResultsProfessionist?.professionists"
                  [professionistObject]="professionist"></app-card-search-professionista>
              </ng-container>

              <!-- PAGINAZIONE -->
              <ul class="pagination pb-5">
                <li *ngIf="this.page > 0" class="page-item mx-2">
                  <a [routerLink]="[]" [queryParams]="{pagina: this.page}" queryParamsHandling="merge" class="page-link"
                    aria-label="pagina precedente"><i class="icon-chevron-left"></i></a>
                </li>

                <ng-container *ngFor="let a of this.main?.counterNgFor(this.ceilPagination); let i = index">
                  <li *ngIf="i <= this.page+this.paginationRange && i >= this.page-this.paginationRange"
                    class="page-item mx-2" [class.active]="this.page == i">
                    <a [routerLink]="[]" [queryParams]="{pagina: i+1}" queryParamsHandling="merge" class="page-link">{{
                      i + 1 }}</a>
                  </li>
                </ng-container>

                <li *ngIf="this.page+1 != this.ceilPagination" class="page-item mx-2">
                  <a [routerLink]="[]" [queryParams]="{pagina: this.page+2}" queryParamsHandling="merge"
                    class="page-link" aria-label="prossima pagina"><i class="icon-chevron-right"></i></a>
                </li>
              </ul>
            </ng-container>
            <ng-template #noResults>
              <ng-container
                *ngIf="(this.searchType == 'agente' || this.searchType == 'professionista') && this.showProfessionist">
                <div class="cardFilters cardFilters--noResults">
                  <div class="cardFilters__right">
                    <div class="d-flex align-items-center mb-3 w-100">
                      <div class="btn btn-primary selectSearchTypeBtn cursor-pointer me-3"
                        (click)="this.selectFilter('agente')"
                        [class.selectSearchTypeBtn_active]="!this.isAgentSelected">Agenti
                        immobiliari
                      </div>

                      <div class="btn btn-primary selectSearchTypeBtn cursor-pointer"
                        (click)="this.selectFilter('professionista')"
                        [class.selectSearchTypeBtn_active]="this.isAgentSelected">Consulenti del
                        credito
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="text-center mt-5 pt-4 mb-5 pb-4">
                <i class="icon-exclamation-triangle text-primary icon-not-found"></i>
                <h5 class="m-0 fw-normal font-weight-600 text-primary">
                  La ricerca filtrata non ha restituito risultati.
                  <ng-container *ngIf="this.searchInvalid">
                    <br>
                    Cerca, seleziona o inserisci una zona valida.
                  </ng-container>
                </h5>
              </div>
            </ng-template>

          </ng-container>
          <ng-template #loadingResultList>
            <div class="text-center mt-5 pt-4 mb-5 pb-4">
              <app-loading></app-loading>
              <p class="m-0 pt-1 fw-normal">
                {{
                (this.retrySearchAgencyMessage || this.retrySearchAnnunciMessage ||
                this.retrySearchProfessionistMessage || this.retrySearchAgentMessage) ? "Cerco dei contenuti simili..."
                : "Caricamento..."
                }}
              </p>
            </div>
          </ng-template>

        </div>

        <!-- RICERCHE RECENTI -->
        <div class="col-lg-3 col-md-12 col-sm-12">

          <div class="card card-save-search" *ngIf="!savedSearch && userSearch">
            <h6 class="mb-2 pb-0"><i class="icon-search-plus me-2"></i>Memorizza la ricerca</h6>
            <p class="pt-0 mt-0 mb-3">Verranno salvati all'interno del tuo profilo.</p>
            <button (click)="saveSearches();" class="btn btn-primary mb-0">Salva la ricerca</button>
          </div>

          <div [class.mb-4]="this.main?.visitedListings?.length === 0"
            *ngIf="!this.handleViewBoxGenericReq && this.searchType !== 'professionista'" class="card card-save-search"
            (click)="handleGenericRequest()">
            <h6 class="mb-2 pb-0"><i class="icon-comment me-2"></i>Chiedi agli agenti immobiliari esperti
              {{ this.createAgentLabel() }}</h6>
            <p class="pt-0 mt-0 mb-3">Chiedi agli agenti immobiliari {{ this.createAgentLabel() }} quali sono
              gli immobili che potrebbero soddisfare al meglio le tue richieste.</p>
            <button class="btn btn-primary mb-0">Fai una richiesta</button>
          </div>


          <!-- BANNER AUXILIA -->
          <!-- <ng-container *ngIf="this.main?.visitedListings && this.main?.visitedListings?.length === 0">
            <div *ngIf="this.showProfessionist"
                [hidden]="this.searchType == 'professionista' || this.searchType == 'agos'"
                [style.order]="1" class="col-lg-12 col-md-6 col-sm-12">
                <app-brand-banner [bannerName]="'agosS'" [imgUrl]="'assets/img/adv/banner_gif_200x200_1910_1.gif'"
                    [marginTop]="20" [marginBottom]="25" [width]="240" [height]="230"></app-brand-banner>
                <img src='https://agos.commander1.com/v3/?tcs=2498&rand=$cachebuster$&chn=partners&src=cercacasa&cmp=cercacasa_QK&pub=&med=desktop&fmt=220x220&brk=QK&adgrp=&aff_id=&aff_name='
                    loading='lazy' width='1' height='1' alt="pixel agos">
            </div> -->

          <!-- BANNER FINANZIARIA -->
          <!-- <div *ngIf="this.showProfessionist" [hidden]="this.searchType == 'professionista' || this.searchType == 'agente'" [style.order]="1" class="col-lg-12 col-md-6 col-sm-12">
                <app-brand-banner [bannerName]="'finanziaria'" [imgUrl]="'assets/img/placeholders/finanziaria-square-banner.png'" [marginTop]="0" [marginBottom]="25" [width]="240" [height]="230"></app-brand-banner>
            </div>
          </ng-container>-->

          <ng-container *ngIf="this.main?.visitedListings?.length > 0">
            <div class="section-title-wrap section-header pt-4 pb-2 mb-0">
              <h5 class="custom-primary">Trova la tua casa</h5>
              <h3 class="title fw-normal">Annunci visitati</h3>
            </div>
            <div class="listCardContainer">
              <div class="row">
                <ng-container *ngFor="let annuncio of this.visitedListing | slice:0:10; let i=index">
                  <div [style.order]="i" class="col-lg-12 col-md-6 col-sm-12">
                    <app-card-search-annunci-recenti [annuncioObj]="annuncio"></app-card-search-annunci-recenti>
                  </div>
                </ng-container>

                <!-- BANNER Agos -->
                <!-- <div *ngIf="this.showProfessionist" [style.order]="1"
                    class="col-lg-12 col-md-6 col-sm-12">
                    <app-brand-banner [bannerName]="'agosS'" [imgUrl]="'assets/img/adv/banner_gif_200x200_1910_1.gif'"
                        [marginTop]="0" [marginBottom]="25" [width]="240"
                        [height]="230"></app-brand-banner>
                    <img src='https://agos.commander1.com/v3/?tcs=2498&rand=$cachebuster$&chn=partners&src=cercacasa&cmp=cercacasa_QK&pub=&med=desktop&fmt=220x220&brk=QK&adgrp=&aff_id=&aff_name='
                        loading='lazy' width='1' height='1' alt="pixel agos">
                </div> -->

                <!-- BANNER Auxilia -->
                <div *ngIf="this.showProfessionist" [style.order]="1" class="col-lg-12 col-md-6 col-sm-12">
                  <app-brand-banner [bannerName]="'auxilia'"
                    [imgUrl]="'assets/img/placeholders/auxilia-square-banner.png'" [marginTop]="0" [marginBottom]="25"
                    [width]="240" [height]="230"></app-brand-banner>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Widget servizi -->
          <div *ngIf="this.showProfessionist && this.showBoxServizi" [style.order]="15"
            class="col-lg-12 col-md-6 col-sm-12">
            <div class="widgetServizi">
              <h6 class="mb-0">Servizi per te</h6>
              <div class="widgetServizi__item d-flex align-items-center">
                <div class="widgetServizi__iconCont d-flex align-items-center justify-content-center">
                  <i class="icon-money-bill-wave"></i>
                </div>
                <div class="widgetServizi__text">
                  <div class="fw-200">Prestito fino a 60.000€</div>
                  <div class="text-decoration-underline">Confronta i migliori</div>
                </div>
              </div>
              <div class="widgetServizi__item d-flex align-items-center my-2">
                <div class="widgetServizi__iconCont d-flex align-items-center justify-content-center">
                  <i class="icon-tv"></i>
                </div>
                <div class="widgetServizi__text">
                  <div class="fw-200">Offerte ADSL</div>
                  <div class="text-decoration-underline">Preventivo Gratis</div>
                </div>
              </div>
              <div class="widgetServizi__item d-flex align-items-center">
                <div class="widgetServizi__iconCont d-flex align-items-center justify-content-center">
                  <i class="icon-money-bill-wave"></i>
                </div>
                <div class="widgetServizi__text">
                  <div class="fw-200">Mobili e decorazione per la casa</div>
                  <div class="text-decoration-underline">Scopri di più</div>
                </div>
              </div>
            </div>
          </div>

          <a (click)="navigateToUserViditingListing()" class="btn btn-primary cursor-pointer whiteColor"
            *ngIf="searchResultsAnnuncio && this.main?.visitedListings?.length > 0 && this.isLogged">
            Vedi gli annunci visitati
          </a>
        </div>

      </div>
    </div>
  </div>

  <app-footer></app-footer>

</div>

<!-- POPUP -->
<app-popup (closePopupEvent)="this.closePopup()" [modalIsOpen]="this.modalIsOpen" [reviewFormIsValid]="true"
  [isReviewPage]="false">
</app-popup>

<!-- SALVA RICERCA FIXED -->
<div class="card-save-search-fixed-container" *ngIf="!this.savedSearch"
  [@slideIn]="this.showSaveSearch ? 'open' : 'close'">
  <div class="card card-save-search card-save-search-fixed">
    <h5 class="mb-2 pb-0"><i class="icon-search-plus me-2"></i>Memorizza la ricerca:
      <span>{{ this.searchPlaceholder }}</span>
    </h5>
    <p class="pt-0 mt-0 mb-3">Verranno salvati all'interno del tuo profilo.</p>
    <p class="pt-0 mt-0 mb-3">La ricerca verrà salvata all'interno del tuo profilo. Ti sarà, così, più facile e
      veloce effettuare la stessa ricerca la prossima volta</p>
    <button (click)="this.saveSearches();" class="btn btn-primary mb-0">Salva la ricerca</button>
    <i class="icon-times close" (click)="this.closeSaveSearch();"></i>
  </div>
</div>

<!-- MOBILE FOOTER MENU -->
<app-mobile-menu></app-mobile-menu>

<!-- POPUP FILTRI RICERCA -->
<app-popup-filtri-ricerca (closeMoreFiltersPopupEvt)="this.closeMoreFilterPopup()"
  (filterSearchChangeEvt)="this.changeFiltersFromPopup($event)" [openMoreFiltersPopup]="this.openMoreFiltersPopup"
  [changeFilterEvent]="this.filterRemovedEvent"></app-popup-filtri-ricerca>

<!-- POPUP RICHIESTE GENERICHE -->
<app-richieste-generiche-popup [loadPopup]="this.loadPopup" [regione]="this.searchRegione"
  [provincia]="this.searchProvincia" [comune]="this.searchComune" [zona]="this.searchZona"
  [searchValue]="this.searchValue" [genericRequestPopupIsOpen]="this.openGenReqPopup"
  (closeGenPopupEvt)="this.openGenReqPopup=false"
  (submitGenPopupEvt)="this.submitGenericRequest($event)"></app-richieste-generiche-popup>